import { ResponsivePie } from '@nivo/pie';

export type PieProps = {
  id: string;
  label: string;
  value: number;
  color: string;
};

type Props = {
  data: PieProps[];
};

const Pie = ({ data }: Props) => {
  const totalValue = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <ResponsivePie
      data={data}
      margin={{ top: 20, right: 200, bottom: 20, left: 20 }}
      innerRadius={0.65}
      padAngle={1.5}
      cornerRadius={1.5}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      colors={(datum) => datum.data.color}
      borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
      arcLabel={(d) => ``}
      arcLinkLabel={(e) =>
        `${e.value} (${((e.value / totalValue) * 100).toFixed(1)}%)`
      }
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
      arcLinkLabelsDiagonalLength={5}
      arcLinkLabelsStraightLength={5}
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          justify: false,
          translateX: 75,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 60,
          itemHeight: 14,
          itemTextColor: '#999',
          itemDirection: 'left-to-right',
          itemOpacity: 1,
          symbolSize: 14,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
      theme={{
        text: {
          fontFamily: 'Poppins, sans-serif',
        },
        legends: {
          text: {
            fontSize: 12,
          },
        },
      }}
      layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends']}
    />
  );
};

export { Pie };
